"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ChatInterface_1 = require("../../BusinessLogicLayer/ChatInterface");
const exception_1 = require("@almservices-cl/exception");
const sendChatMessageFactory_1 = __importDefault(require("./graphql/sendChatMessageFactory"));
const sendChatMessageWithAttachmentFactory_1 = __importDefault(require("./graphql/sendChatMessageWithAttachmentFactory"));
const chatQueryFactory_1 = __importDefault(require("./graphql/chatQueryFactory"));
const bold = {
    type: ChatInterface_1.RichPartMethodType.TYPOGRAPHICAL_EMPHASIS,
    subType: ChatInterface_1.TypographicalEmphasis.BOLD,
};
const mapPart = (part) => {
    switch (part.name) {
        case "PlainText":
            return {
                text: part === null || part === void 0 ? void 0 : part.text,
                name: ChatInterface_1.MessagePartType.TEXT,
            };
        case "RichText":
            return {
                name: ChatInterface_1.MessagePartType.RICH_TEXT,
                text: part === null || part === void 0 ? void 0 : part.text,
                methods: part === null || part === void 0 ? void 0 : part.methods.filter((p) => p.name === "TypographicalEmphasis" && p.method === "bold").map(() => bold),
            };
        case "Link":
            return {
                name: ChatInterface_1.MessagePartType.LINK,
                url: part.url,
                label: part.label,
            };
        case "Date":
            return {
                name: ChatInterface_1.MessagePartType.DATE,
                isoDate: part.date.iso8601,
            };
        case "BackwardCompatibility":
            return {
                text: part.plain,
                name: ChatInterface_1.MessagePartType.TEXT,
            };
    }
};
const mapLevel = (metadata) => {
    switch (metadata.type) {
        case "INFO":
            return ChatInterface_1.MessageLevel.INFO;
        case "WARN":
            return ChatInterface_1.MessageLevel.WARN;
    }
    return null;
};
const mapping = ({ from, id, sent, metadata, parts, attachment, }) => {
    return {
        authorId: from.id,
        authorDisplayName: from.firstName + " " + from.lastName,
        message: {
            isoDateTime: sent,
            messageParts: parts
                .map(mapPart)
                .filter((msg) => msg !== null),
            id: id.toString(),
            attachment: (attachment === null || attachment === void 0 ? void 0 : attachment.__typename) === "PhotoMedia"
                ? attachment
                : null,
        },
        level: mapLevel(metadata),
    };
};
const args = (param) => {
    var _a, _b, _c;
    return {
        interlocutor: param.interlocutor ? parseInt(param.interlocutor) : null,
        after: (_a = param.after) !== null && _a !== void 0 ? _a : null,
        before: (_b = param.before) !== null && _b !== void 0 ? _b : null,
        limit: (_c = param.limit) !== null && _c !== void 0 ? _c : null,
    };
};
class Chat {
    constructor(client, httpClient, application) {
        this.after = async (messageId, withMemberId) => {
            const response = await this.client.fetch("chat", this.readQuery, args({
                interlocutor: withMemberId !== null && withMemberId !== void 0 ? withMemberId : null,
                after: messageId,
                limit: 20,
            }));
            return response.chat.reverse().map(mapping);
        };
        this.before = async (limit, messageId, withMemberId) => {
            const response = await this.client.fetch("chat", this.readQuery, args({
                interlocutor: withMemberId !== null && withMemberId !== void 0 ? withMemberId : null,
                before: messageId,
                limit,
            }));
            return response.chat.reverse().map(mapping);
        };
        this.send = async (message, withMemberId, attachmentMediaId) => {
            const response = await this.client.fetch("sendChatMessage", this.writeQuery, {
                receiver: withMemberId === null ? null : parseInt(withMemberId),
                text: message,
                attachmentMediaId,
            });
            if (response.sendChatMessage.chatMessage.id) {
                return response.sendChatMessage.chatMessage.id.toString();
            }
            throw new exception_1.NetworkException("Message could not be send!");
        };
        this.sendChatMessageWithAttachment = async (message, withMemberId, attachmentMediaId) => {
            const response = await this.client.fetch("sendChatMessage", this.writeWithAttachmentQuery, {
                receiver: withMemberId === null ? null : parseInt(withMemberId),
                text: message,
                attachmentMediaId,
            });
            return response.sendChatMessage.chatMessage;
        };
        this.sendAttachment = async (attachment, caption, memberId, galleryId) => {
            const formData = new FormData();
            formData.append("file", attachment, attachment.name);
            formData.append("caption", caption);
            galleryId && formData.append("gallery_id", galleryId);
            try {
                const res = await this.httpClient.post(`/v1/media`, formData, true, {
                    "Content-Type": "multipart/form-data",
                });
                try {
                    return await this.sendChatMessageWithAttachment(null, memberId, res.media_id);
                }
                catch (e) {
                    await this.httpClient.delete(`/v1/media/${res.media_id}`);
                    throw e;
                }
            }
            catch (e) {
                throw e;
            }
        };
        this.client = client;
        this.httpClient = httpClient;
        this.readQuery = (0, chatQueryFactory_1.default)(application);
        this.writeQuery = (0, sendChatMessageFactory_1.default)(application);
        this.writeWithAttachmentQuery =
            (0, sendChatMessageWithAttachmentFactory_1.default)(application);
    }
}
exports.default = Chat;
//# sourceMappingURL=Chat.js.map